export default "__VITE_ASSET__COyFVZPV__"